import BannerWithForm from "./_components/banner-with-form";

export default BannerWithForm;
